import * as React from 'react';

import { useURLSearchParam } from '@shared/hooks/use_url_search_param';

import { Permission } from '@admin/components/helpers/permission';
import { logisticsDetailedSKUURL } from '@admin/config/routes';
import { useTitle } from '@admin/hooks/use_title';
import { LOGISTICS } from '@admin/libraries/access_control_catalog.generated';
import { Logistics__Sku__CountingUnitEnum, Logistics__SkuTeachInStatusEnum } from '@admin/schema';

import { LogisticsSkuForm, NewFormData } from './form/form';

export const LogisticsNewSku: React.FC = () => {
  useTitle('Create SKU');
  const [accountID] = useURLSearchParam('accountID');

  const formData: NewFormData = {
    accountID: accountID!,
    value: '',
    description: '',
    hasBarcode: false,
    defaultPalletTypeID: '0',
    defaultPalletHeightValue: 0,
    teachInStatus: Logistics__SkuTeachInStatusEnum.Pending,
    countingUnit: Logistics__Sku__CountingUnitEnum.MasterCarton,
  };

  const onSubmit = async (id?: string) => {
    if (id) {
      window.location.href = logisticsDetailedSKUURL({ id: id });
    }
  };

  return (
    <Permission resource={LOGISTICS.resource} action={LOGISTICS.actions.update}>
      <LogisticsSkuForm formData={formData} onSave={onSubmit} />
    </Permission>
  );
};
